export { MotionValue } from './MotionValue.es.js';
